import React, { useEffect, useState } from 'react'
import MUIDataTable from 'mui-datatables'

import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import NotFoundMessage from 'components/NotFoundMessage'
import TableLoadingAnimation from 'components/TableLoadingAnimation'
import { Add } from '@mui/icons-material'
import moment from 'moment'

import { DialogConfirm } from 'components'

import generateOptions from '../generateOptions'
import { columns } from './columns'
import CompaniesForm from './CompaniesForm'
import { deleteCompanyKeyword, loadCompanyKeywords } from "../../../services/apiKYP"
import { OPERATION_MESSAGES } from "../../../utils/constants/operations"

function CompaniesKeywords() {
  const token = useSelector((state) => state.auth.access_token)

  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [showEditorDialog, setShowEditorDialog] = useState(false)
  const [showRemoveDialog, setShowRemoveDialog] = useState(false)
  const [selectedKeyword, setSelectedKeyword] = useState(null)

  const handleAdd = () => {
    setShowEditorDialog(true)
  }

  const handleEdit = (keyword) => {
    setSelectedKeyword(keyword)
    setShowEditorDialog(true)
  }

  const handleOpenRemove = (keyword) => {
    setSelectedKeyword(keyword)
    setShowRemoveDialog(true)
  }

  const actions = [
    {
      icon: Add,
      callback: handleAdd,
      tooltip_text: 'Adicionar nova palavra-chave',
    },
  ]

  const filename = `palavras_chave_empresas_${moment().format(
    'DD_MM_YYYY_HH_mm_ss',
  )}`

  const options = generateOptions(filename, actions)

  const initializeDataState = (rawData) => {
    if (rawData?.length > 0) {
      const transformedData = rawData.map((row) => ({
        ...row,
        actions: {
          edit: () => handleEdit(row),
          remove: () => handleOpenRemove(row),
        },
      }))
      setData(transformedData)
    }
  }

  const loadData = () => {
    setLoading(true)
    
    loadCompanyKeywords(token)
      .then((response) => {
        initializeDataState(response.data)
      })
      .catch((error) => {
        console.error(error)
        toast.error(OPERATION_MESSAGES.LOAD_DATA_FAIL)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleClose = () => {
    setShowEditorDialog(false)
    setShowRemoveDialog(false)
    setSelectedKeyword(null)
    loadData()
  }

  const handleDelete = async () => {
    deleteCompanyKeyword(token, selectedKeyword.uuid)
      .then((response) => {
        if (response.status === 204) {
          toast.success(OPERATION_MESSAGES.RECORD_REMOVE_SUCCESS)
          handleClose()
        }
      })
      .catch(() => {
        toast.error(OPERATION_MESSAGES.RECORD_REMOVE_FAIL)
      })
  }

  useEffect(() => {
    loadData()
  }, [])

  return (
    <div>
      {loading ? (
        <TableLoadingAnimation />
      ) : data.length > 0 ? (
        <MUIDataTable data={data} columns={columns} options={options} />
      ) : (
        <NotFoundMessage message='Nenhum resultado encontrado' />
      )}

      <CompaniesForm keyword={selectedKeyword} open={showEditorDialog} handleClose={handleClose} />

      <DialogConfirm
        open={showRemoveDialog}
        title="Confirmar remoção da palavra-chave"
        onCancel={handleClose}
        onConfirm={handleDelete}
        contextText={OPERATION_MESSAGES.PERMANENT_ACTION_CONFIRMATION}
      />
    </div>
  )
}

export default CompaniesKeywords
